<!-- Skeleton loading -->
<section *ngIf="carregando" class="space-y-3">
  <div
    *ngFor="let i of [1, 2, 3]"
    class="rounded-2xl bg-white border border-gray-200 p-4 shadow-sm animate-pulse dark:bg-gray-800 dark:border-gray-700">
    <div class="h-3 w-2/5 rounded bg-gray-200 dark:bg-gray-700 mb-3"></div>
    <div class="h-4 w-3/4 rounded bg-gray-200 dark:bg-gray-700 mb-4"></div>
    <div class="flex items-end justify-between">
      <div class="space-y-2">
        <div class="h-5 w-24 rounded-full bg-gray-200 dark:bg-gray-700"></div>
        <div class="h-3 w-36 rounded bg-gray-200 dark:bg-gray-700"></div>
      </div>
      <div class="h-11 w-11 rounded-xl bg-gray-200 dark:bg-gray-700"></div>
    </div>
  </div>
</section>

<!-- ───── Empty states bloqueantes ───── -->

<!-- Cenário A: Turma sem calendário escolar (turmas normais) -->
<app-empty-state
  *ngIf="semCalendario && !carregando"
  imagem="assets/images/professor-nao-possui-turmas.png"
  titulo="Esta turma não possui calendário escolar definido"
  descricao="Procure o(a) secretário(a) do seu estabelecimento de ensino para preencher estas informações no Cadastro de Turmas.">
</app-empty-state>

<!-- Cenário B: Componente modular/atividade sem período avaliativo definido -->
<app-empty-state
  *ngIf="semPeriodoAvaliativo && !carregando"
  imagem="assets/images/professor-nao-possui-turmas.png"
  titulo="Este componente curricular não possui as datas inicial e final definidas para o período avaliativo"
  descricao="Procure o(a) secretário(a) do seu estabelecimento de ensino para preencher estas informações no Cadastro de Turmas.">
</app-empty-state>

<!-- ──────────────────────────────────────────────────────────────────── -->

<!-- Lista vazia (tem calendário/período, mas sem registros) -->
<app-empty-state
  *ngIf="listaVazia"
  tema="slate"
  icone="book-open"
  titulo="Ainda não há conteúdos por aqui."
  descricao="Para criar um planejamento, acesse o sistema através da versão web." >
</app-empty-state>

<!-- Lista de cards -->
<ng-container *ngIf="!semCalendario && !semPeriodoAvaliativo && registros.length > 0 && !carregando">
  <section class="space-y-3">
    <article
      *ngFor="let registro of registros; trackBy: trackByRegistro"
      class="registro-card">

      <!-- Bloco esquerdo: textos informativos + badge de situação -->
      <div class="flex-1 min-w-0 pr-12">

        <!-- 1. Período -->
        <p class="card-field leading-tight">
          <span class="font-bold">Período:</span>
          {{ formatarPeriodo(registro) }}
        </p>

        <!-- 2. Disciplina(s) -->
        <p class="card-field leading-tight" [class.animate-pulse]="isCarregandoDisciplinas(registro)">
          <span class="font-bold">Disciplina(s):</span>
          {{ registro.disciplinasCalculadas ?? 'Aguardando...' }}
        </p>

        <!-- 3. Conteúdo -->
        <p class="card-field leading-snug line-clamp-2" title="{{ registro.titulo }}">
          <span class="font-bold mr-1">Conteúdo:</span>{{ registro.titulo }}
        </p>

        <!-- 4. Observação (opcional) -->
        <p *ngIf="registro.observacao" class="card-field leading-snug break-words">
          <span class="font-bold">Observação:</span> {{ registro.observacao }}
        </p>

        <!-- 5. Badge de situação -->
        <div *ngIf="exibirSituacaoListagem(registro)" class="mt-3">
          <span
            class="badge-status py-[3px]"
            [ngClass]="getSituacaoBadgeClass(registro.situacaoAprovacaoRaw)">
            {{ getSituacaoLabel(registro.situacaoAprovacaoRaw) }}
          </span>
        </div>

      </div>

      <!-- Botão visualizar -->
      <button
        type="button"
        (click)="visualizar.emit(registro)"
        class="btn-visualizar"
        title="Visualizar planejamento"
        aria-label="Visualizar planejamento">
        <lucide-icon name="eye" class="h-5 w-5"></lucide-icon>
      </button>

    </article>
  </section>
</ng-container>
